export const PRODUCT_MANAGER_MANAGE_SCOPES = ['product-manager:manage:all']
